import { RouteRecordRaw } from "vue-router";

// 404 on a page
export const PAGE_NOT_FOUND_ROUTE: RouteRecordRaw = {
  path: "/:path(.*)*",
  name: "PageNotFound",
  component: () => import("/@/views/error/Page404.vue"),
  meta: {
    title: "404 Not Found",
    ignoreAuth: true,
    hideMenu: true,
  },
};

export const LoginRoute: RouteRecordRaw = {
  path: "/login",
  name: "Login",
  component: () => import("/@/views/login/LoginPage.vue"),
  meta: {
    title: "登录",
    ignoreAuth: true,
    hideMenu: true,
  },
};

export const basicRoutes = [LoginRoute, PAGE_NOT_FOUND_ROUTE];
